var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,14c3.3,0,6-2.7,6-6s-2.7-6-6-6-6,2.7-6,6,2.7,6,6,6ZM8,15c-3.9,0-7-3.1-7-7S4.1,1,8,1s7,3.1,7,7-3.1,7-7,7Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circleIcon.113922d3237d329516f1e6e28d25b2ea.svg";